export function getOpacity(targets: gsap.TweenTarget): number {
  if (!Array.isArray(targets) && targets instanceof Element) {
    return Number(targets.getAttribute('opacity') ?? 1);
  }

  return 1;
}

export function getTransform(targets: gsap.TweenTarget): string {
  if (!Array.isArray(targets) && targets instanceof Element) {
    return String(targets.getAttribute('transform'));
  }

  return '';
}

export function getRotationAngle(targets: gsap.TweenTarget): number {
  if (!Array.isArray(targets) && targets instanceof Element) {
    return Number(getElementRotation(targets));
  }

  return 0;

  function getElementRotation(element: Element, defaultAngle = 0) {
    const transform = element.getAttribute('transform');

    if (!transform || !transform?.includes('rotate')) return defaultAngle;

    return transform.split('rotate(')[1].split(')')[0].split(' ')[0];
  }
}

export function getBBox(element: Element): DOMRect | undefined {
  if ('getBBox' in element) {
    return (element as any).getBBox();
  }

  return undefined;
}

export function createAnimationContainer(target: any) {
  if (!target?.parentElement) return target;

  const animationContainer = document.createElementNS('http://www.w3.org/2000/svg', 'g');

  animationContainer.setAttribute('class', 'animation-container');

  target.insertAdjacentElement('afterend', animationContainer);
  animationContainer.appendChild(target);

  return animationContainer;
}
